import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    position: 'relative',
    width: '100%',
  },
  resultsMessage: {
    fontWeight: 600,
    maxWidth: pxToRem(420),
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  resultsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: pxToRem(1204),
    paddingTop: pxToRem(20),
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  searchFieldsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: pxToRem(1204),
  },
  search: {
    maxWidth: pxToRem(320),
    width: pxToRem(312),
    selectors: {
      '&::before': {
        content: '" "',
        position: 'absolute',
        height: '70%',
        width: pxToRem(1),
        top: '15%',
        left: '-1px',
        backgroundColor: theme.palette.neutralQuaternary,
      },
    },
  },
  selectDeselectButtonsContainer: {
    position: 'relative',
    right: '0',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: pxToRem(1204),
  },
  textButton: {
    paddingRight: 0,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  cancelButton: {
    marginRight: pxToRem(20),
    marginLeft: pxToRem(20),
    fontWeight: 400,
  },
  removeButton: {
    height: pxToRem(20),
    marginRight: pxToRem(20),
    marginLeft: pxToRem(20),
    fontWeight: 400,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
    },
  },
  iconColumnHeaderSelectButton: {
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        top: pxToRem(14),
        left: pxToRem(7),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
      '& .ms-DetailsHeader-cellName .ms-Icon': {
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
        paddingLeft: pxToRem(8),
      },
    },
  },
  selectButton: {
    top: pxToRem(1),
    left: pxToRem(8),
    height: 'auto',
  },
  selectedButton: {
    top: pxToRem(1),
    left: pxToRem(8),
    height: 'auto',
    opacity: 0.5,
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  permissionList: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        height: 'auto',
        maxHeight: pxToRem(450),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  },
  toggleColumn: {
    paddingTop: '0.2rem',
  },
  pill: {
    height: '1rem',
  },
});
